import { render, staticRenderFns } from "./BaseHour.vue?vue&type=template&id=8f2efd90"
import script from "./BaseHour.vue?vue&type=script&lang=js"
export * from "./BaseHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports